import { render, staticRenderFns } from "./Switchboard.vue?vue&type=template&id=5d18c66c&"
import script from "./Switchboard.vue?vue&type=script&lang=ts&"
export * from "./Switchboard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports